// Login.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';   // <--- Link importieren
import { API_DJANGO_URL, APP_NAME } from '../config/config.mjs';
import './Login.css';

// Zentrale Logout-Funktion
export const performLogout = () => {
  // Alle Token entfernen
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('username');
  
  // Session Storage leeren
  sessionStorage.clear();
  
  // Axios Headers zurücksetzen
  delete axios.defaults.headers.common['Authorization'];
  
  console.log('Logout erfolgreich - alle Daten gelöscht');
};

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token && token !== 'null') {
      console.log('Token gefunden, weiterleiten zu /chat...');
      navigate('/', { replace: true });
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    const data = {
      username: username,
      password: password,
    };

    try {
      const response = await axios.post(`${API_DJANGO_URL}/api-roby/login/`, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        const { access, refresh } = response.data;
        //console.log('Access Token:', access);
        //console.log('Refresh Token:', refresh);
        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);
        
        // Authorization Header setzen
        axios.defaults.headers.common['Authorization'] = `Bearer ${access}`;
        
        console.log('Tokens in localStorage gespeichert');

        if (onLoginSuccess) {
          onLoginSuccess(access);
        }

        setTimeout(() => {
          navigate('/', { replace: true });
        }, 200);
      }
    } catch (error) {
      console.error('Authentifizierungsfehler:', error);
      setError('Login fehlgeschlagen: Falscher Benutzername oder Passwort');
    }
  };

  const handleLogout = () => {
    // Verwende die zentrale Logout-Funktion
    performLogout();
    
    // State zurücksetzen
    setUsername('');
    setPassword('');
    setError('');
    
    // Navigation zum Login
    navigate('/login', { replace: true });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Willkommen im {APP_NAME}!</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <button type="submit">Login</button>
        </form>

        {/* Passwort vergessen Link */}
        <div className="forgot-password">
          <Link to="/forgot-password">Passwort vergessen?</Link>
        </div>

        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
